import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=6f7d12d6&scoped=true"
import script from "./Classify.vue?vue&type=script&lang=js"
export * from "./Classify.vue?vue&type=script&lang=js"
import style0 from "./Classify.vue?vue&type=style&index=0&id=6f7d12d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7d12d6",
  null
  
)

export default component.exports